import { render, staticRenderFns } from "./InventoryStockPrint.vue?vue&type=template&id=6f8478f9&scoped=true&"
import script from "./InventoryStockPrint.vue?vue&type=script&lang=js&"
export * from "./InventoryStockPrint.vue?vue&type=script&lang=js&"
import style0 from "./InventoryStockPrint.vue?vue&type=style&index=0&id=6f8478f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8478f9",
  null
  
)

export default component.exports